import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import UserServices from '../../services/UserServices';

function UserUpdate({ user, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    deviceType: '',
    firstName: '',
    lastName: '',
    email: '',
    mobileNo: '',
    state: '',
    city: '',
    address: '',
    bulding: '',
    apartment: '',
    floor: '',
    street: ''
  });
  const [addressType, setAddressType] = useState(''); // Add state for address type
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path

  useEffect(() => {
    if (user) {
      setFormValues({
        deviceType: user?.deviceType || '',
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        mobileNo: user?.mobileNo || '',
        address: user?.address || '',
        state: user?.state || '',
        city: user?.city || '',
        floor: user?.floor || '',
        bulding: user?.bulding || '',
        apartment: user?.apartment || '',
        street: user?.street || ''

      });
      setAddressType(user?.addressType || '');
      if (user.image) {
        setPreviewImage(process.env.REACT_APP_URL + user.image);
      }
    }
  }, [user]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleAddressTypeChange = (event) => {
    setAddressType(event.target.value); // Update address type when user selects a radio button
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await UserServices.updateUser(user.id, formData);
      alert('User updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update  user', error);
      alert('Failed to update  user');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>User Type</label>
                          <input type="text" name="deviceType" className="form-control" value={formValues.deviceType} onChange={handleInputChange} placeholder="New Type"  />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>First Name*</label>
                          <input type="text" name="firstName" className="form-control" value={formValues.firstName} onChange={handleInputChange} placeholder="New first name" required />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Last Name*</label>
                          <input type="text" name="lastName" className="form-control" value={formValues.lastName} onChange={handleInputChange} placeholder="New Last Name" required />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Mobile No*</label>
                          <input
                            type="tel"
                            name="mobileNo"
                            className="form-control"
                            value={formValues.mobileNo}
                            onChange={handleInputChange}
                            pattern="[0-9]{10}"
                            maxLength="10"
                            placeholder="New mobile"
                            required
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Email</label>
                          <input type="text" name="email" className="form-control" value={formValues.email} onChange={handleInputChange} placeholder="New email" readOnly  />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>State</label>
                          <input type="text" name="state" className="form-control" value={formValues.state} onChange={handleInputChange} placeholder="New state"  />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>City</label>
                          <input type="text" name="city" className="form-control" value={formValues.city} onChange={handleInputChange} placeholder="New city"  />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Address</label>
                          <input type="text" name="address" className="form-control" value={formValues.address} onChange={handleInputChange} placeholder="New address"  />
                        </div>
                      </div>


                      <div className="col-lg-3 col-sm-3">
                        <div className="input-field">
                          <label>Building*</label>
                          <input type="text" name="bulding" className="form-control" value={formValues.bulding} onChange={handleInputChange} placeholder="New Building" required />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-3">
                        <div className="input-field">
                          <label>Apartment*</label>
                          <input type="text" name="apartment" className="form-control" value={formValues.apartment} onChange={handleInputChange} placeholder="New Apartment" required />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-3">
                        <div className="input-field">
                          <label>Floor*</label>
                          <input type="text" name="floor" className="form-control" value={formValues.floor} onChange={handleInputChange} placeholder="New floor" required />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-3">
                        <div className="input-field">
                          <label>Street*</label>
                          <input type="text" name="street" className="form-control" value={formValues.street} onChange={handleInputChange} placeholder="New street" required />
                        </div>
                      </div>
                         {/* Address Type Radio Button Section */}
                         <div className="col-sm-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="addressType"
                            value="Home"
                            id="flexRadioDefault1"
                            checked={addressType === 'Home'}
                            onChange={handleAddressTypeChange}
                          />
                          <label className="form-check-label" htmlFor="flexRadioDefault1">
                            Set as current home address
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="addressType"
                            value="Office"
                            id="flexRadioDefault2"
                            checked={addressType === 'Office'}
                            onChange={handleAddressTypeChange}
                          />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            Set as office address
                          </label>
                        </div>
                      </div>



                      {/* <div className="col-sm-9">
                        <div className="input-field">
                          <label>Upload<span className="red">*</span></label>
                          <input type="file" name="image" className="form-control" onChange={handleFileChange}  />
                          <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                          <div className="file-preview text-center">
                            <img id="uploadFile" src={previewImage} alt="your image" />
                          </div>
                        </div>
                      </div> */}

                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserUpdate;
